import { render, staticRenderFns } from "./NoticeOfDissolutionOfPartnership.vue?vue&type=template&id=0ce17ce9&scoped=true&"
import script from "./NoticeOfDissolutionOfPartnership.vue?vue&type=script&lang=js&"
export * from "./NoticeOfDissolutionOfPartnership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce17ce9",
  null
  
)

export default component.exports